import { AppBar, Container, Toolbar, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { ZoomMtg } from '@zoom/meetingsdk';
import ZoomMtgEmbedded from "@zoom/meetingsdk/embedded"
import studentApiService from "../../../utlis/apiStudent";

const ZoomMeet = () => {
    const [isSDKReady, setIsSDKReady] = useState(true);
    const [isJoined, setIsJoined] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [meetingConfig, setMeetingConfig] = useState({
        meetingNumber: '89843299747 ',
        password: 'ZoYeD55Z2raKloCQkfHEMGAbtiJE6a.1',
        userName: '',
        userEmail: ''
    });
    let zoomClient;

    const ZOOM_SDK_KEY = 'ZK_6UAl1SNqeKVekOwvHag';

    const loadZoomSDK = async () => {
        try {
            setError('');
            try {
                const meetingSDKElement = document.getElementById('meetingSDKElement')
                // Create client
                const zoomClient = ZoomMtgEmbedded.createClient();

                // ZoomMtgEmbedded.preLoadWasm()
                // ZoomMtgEmbedded.prepareWebSDK()
        
                // Initialize the SDK
                const initResult = zoomClient.init({
                    zoomAppRoot: meetingSDKElement,
                    language: 'en-US',
                    patchJsMedia: true,
                    leaveOnPageUnload: true,
                    customize: {
                    // video: {
                    //     isResizable: true,
                    //     viewSizes: {
                    //     default: {
                    //         width: '100%',
                    //         height: '100%',
                    //     },
                    //     },
                    // },
                    // meetingInfo: ['topic', 'host', 'mn', 'pwd', 'invite', 'participant'],
                    // toolbar: {
                    //     buttons: []
                    // },
                    },
                }).then(async () => {
                    generateSignature(meetingConfig.meetingNumber).then((signature) => {
                        console.log(signature,' signature------');

                        zoomClient.join({
                            sdkKey: ZOOM_SDK_KEY,
                            signature: signature,
                            meetingNumber: meetingConfig.meetingNumber,
                            password: meetingConfig.password,
                            userName: meetingConfig.userName,
                            userEmail: meetingConfig.userEmail,
                        });
                    });
                }).catch((error) => {
                    console.error('Failed to join meeting:', error)
                });
          
                console.log('Embedded SDK initialized:', initResult);
                setIsSDKReady(true);
                return;
            } catch (embeddedError) {
                console.log('Embedded SDK failed, trying regular SDK:', embeddedError);
                
                // Method 2: Try regular meeting SDK
                const ZoomMtg = await import('@zoom/meetingsdk');
                
                
                // Set Zoom SDK settings
                ZoomMtg.ZoomMtg.setZoomJSLib('https://source.zoom.us/lib', '/av');
                ZoomMtg.ZoomMtg.preLoadWasm();
                ZoomMtg.ZoomMtg.prepareWebSDK();
                
                // Store reference for later use
                window.ZoomMtgInstance = ZoomMtg.ZoomMtg;
                
                console.log('Regular SDK initialized');
                setIsSDKReady(true);
            }
        } catch (error) {
            console.error('Failed to load Zoom SDK:', error);
            setError(`SDK loading failed: ${error.message}`);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setMeetingConfig(prev => ({
          ...prev,
          [name]: value
        }));
    };

    const generateSignature = async (meetingNumber, role = 0) => {
        try {
          // This should call your backend API
          const response = await studentApiService.post('/user/zoom/signature', { meetingNumber: meetingNumber }, {
            headers: { 'Content-Type': 'application/json' }
          });
          
          if (!response) {
            throw new Error('Failed to generate signature');
          }
          
          const { signature } = response?.data;

          return signature;
        } catch (error) {
          console.error('Error generating signature:', error);
          // For demo purposes, return a placeholder
          // In production, this should never be used
          throw new Error('Signature generation failed. Please implement backend API.');
        }
    };
    
    const joinMeetingEmbedded = async () => {
        // if (!zoomClient.current) {
        //   throw new Error('Embedded client not initialized');
        // }
    
        const signature = await generateSignature(meetingConfig.meetingNumber);
    
        await zoomClient.join({
          sdkKey: ZOOM_SDK_KEY,
          signature: signature,
          meetingNumber: meetingConfig.meetingNumber,
          password: meetingConfig.password,
          userName: meetingConfig.userName,
          userEmail: meetingConfig.userEmail,
        });
    };
    
    const joinMeetingRegular = async () => {
        if (!window.ZoomMtgInstance) {
          throw new Error('Regular SDK not initialized');
        }
    
        const signature = await generateSignature(meetingConfig.meetingNumber);
    
        return new Promise((resolve, reject) => {
          window.ZoomMtgInstance.init({
            leaveUrl: window.location.origin,
            patchJsMedia: true,
            leaveOnPageUnload: true,
            success: () => {
              window.ZoomMtgInstance.join({
                signature: signature,
                sdkKey: ZOOM_SDK_KEY,
                meetingNumber: meetingConfig.meetingNumber,
                passWord: meetingConfig.password,
                userName: meetingConfig.userName,
                userEmail: meetingConfig.userEmail,
                success: resolve,
                error: reject
              });
            },
            error: reject
          });
        });
    };
    
    const joinMeeting = async () => {
        if (!isSDKReady) {
          alert('SDK not ready yet. Please wait.');
          return;
        }
    
        if (!meetingConfig.meetingNumber || !meetingConfig.userName) {
          alert('Please fill in meeting number and your name.');
          return;
        }
    
        setIsLoading(true);
        setError('');
    
        try {
          // Try embedded SDK first, then fall back to regular SDK
        //   if (zoomClient.current) {
        //     await joinMeetingEmbedded();
        //   } else if (window.ZoomMtgInstance) {
        //     await joinMeetingRegular();
        //   } else {
        //     throw new Error('No Zoom SDK available');
        //   }
          
          setIsJoined(true);
          console.log('Successfully joined meeting');
    
        } catch (error) {
          console.error('Join meeting error:', error);
          setError(`Failed to join: ${error.message || error.reason || 'Unknown error'}`);
        } finally {
          setIsLoading(false);
        }
    };
    
    const leaveMeeting = async () => {
        try {
        //   if (zoomClient.current) {
        //     await zoomClient.current.leaveMeeting();
        //   } else if (window.ZoomMtgInstance) {
        //     window.ZoomMtgInstance.leaveMeeting({});
        //   }
          setIsJoined(false);
          setError('');
        } catch (error) {
          console.error('Leave meeting error:', error);
        }
    };

    return (
        <Container maxWidth={'100%'} sx={{ paddingLeft: 0 }} style={{ padding: 0 }}>
            <AppBar position="static" sx={{ marginBottom: 2 }}>
                <Toolbar>
                    <Typography variant="h6" component="div">
                        Zoom Meeting
                    </Typography>
                </Toolbar>
            </AppBar>

            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
                <div className="max-w-6xl mx-auto p-6">
                    <div className="text-center mb-8">
                    <h1 className="text-4xl font-bold text-gray-800 mb-2">
                        Zoom Meeting Integration
                    </h1>
                    <p className="text-gray-600">
                        Using @zoom/meetingsdk package
                    </p>
                    </div>

                    {/* SDK Status */}
                    <div className="mb-6 flex items-center space-x-4">
                    <div className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                        isSDKReady 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-yellow-100 text-yellow-800'
                    }`}>
                        <div className={`w-2 h-2 rounded-full mr-2 ${
                        isSDKReady ? 'bg-green-500' : 'bg-yellow-500'
                        }`}></div>
                        {isSDKReady ? 'SDK Ready' : 'Loading SDK...'}
                    </div>

                    {error && (
                        <div className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm">
                        {error}
                        </div>
                    )}
                    </div>

                    {!isJoined ? (
                    <div className="bg-white rounded-xl shadow-xl p-8 mb-8">
                        <div className="flex items-center mb-6">
                        <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mr-4">
                            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-semibold text-gray-800">
                            Join Meeting
                        </h2>
                        </div>
                        
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
                        <div className="space-y-4">
                            <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Meeting ID *
                            </label>
                            <input
                                type="text"
                                name="meetingNumber"
                                value={meetingConfig.meetingNumber}
                                onChange={handleInputChange}
                                placeholder="123 456 7890"
                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            />
                            </div>

                            <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Password
                            </label>
                            <input
                                type="password"
                                name="password"
                                value={meetingConfig.password}
                                onChange={handleInputChange}
                                placeholder="Meeting Password"
                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            />
                            </div>
                        </div>

                        <div className="space-y-4">
                            <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Your Name *
                            </label>
                            <input
                                type="text"
                                name="userName"
                                value={meetingConfig.userName}
                                onChange={handleInputChange}
                                placeholder="Enter your display name"
                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            />
                            </div>

                            <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Email (Optional)
                            </label>
                            <input
                                type="email"
                                name="userEmail"
                                value={meetingConfig.userEmail}
                                onChange={handleInputChange}
                                placeholder="your.email@example.com"
                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            />
                            </div>
                        </div>
                        </div>

                        <button
                        onClick={loadZoomSDK}
                        disabled={!isSDKReady || !meetingConfig.meetingNumber || !meetingConfig.userName || isLoading}
                        className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 disabled:from-gray-400 disabled:to-gray-500 text-white font-semibold py-4 px-6 rounded-lg transition-all duration-200 transform hover:scale-[1.02] disabled:scale-100 disabled:cursor-not-allowed shadow-lg flex items-center justify-center"
                        >
                        {isLoading ? (
                            <>
                            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Joining Meeting...
                            </>
                        ) : (
                            'Join Meeting'
                        )}
                        </button>
                    </div>
                    ) : (
                        <div className="mb-6 flex space-x-4">
                            <button
                                onClick={leaveMeeting}
                                className="bg-red-600 hover:bg-red-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg"
                            >
                                Leave Meeting
                            </button>
                        </div>
                    )}

                    {/* Zoom Meeting Container */}
                    <div className="bg-white rounded-xl shadow-xl overflow-hidden mb-8">
                        <div 
                            id="meetingSDKElement"
                            style={{ 
                            width: '100%', 
                            height: isJoined ? '600px' : '300px',
                            minHeight: '300px',
                            backgroundColor: isJoined ? '#000' : '#f8f9fa'
                            }}
                            className="relative"
                        >
                            
                        </div>
                    </div>

                </div>
            </div>
        </Container>
    )
}

export default ZoomMeet;